/**
 * MSM-Partner-Dashboard (2026-10-12): eigene, helle Seite ohne internes Menue. Fuer MSM-Nutzer der Gruppe
 * msm_partner die einzige Seite; interne Nutzer erreichen sie ueber das Menue ("MSM Partner").
 * Daten: GET /api/msm-partner/overview — Vertrag in node-app/src/services/msmDelivery/msmPartnerTypes.ts.
 * Die Darstellung liegt in PartnerView.tsx (geteilt mit dem Spiegel im MSM-Cockpit, embed.tsx).
 */
import { Button, Link } from '@mui/material';
import { FC, useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import { api } from '../../helpers/apiUtils';
import { isPartnerOnly } from '../../helpers/routeAccess';
import { PartnerDashboardView } from './PartnerView';
import { C } from './ui';
import type { MsmPartnerOverview } from './types';

async function abmelden() {
  try {
    await api.post('/api/auth/logout');
  } finally {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }
}

const MsmPartnerPage: FC = () => {
  const userInfo = useContext(UserContext);
  const [data, setData] = useState<MsmPartnerOverview | null>(null);
  const [fehler, setFehler] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/api/msm-partner/overview')
      .then((r) => {
        if (!cancelled) setData(r.data?.data ?? null);
      })
      .catch(() => {
        if (!cancelled) setFehler(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const partner = isPartnerOnly(userInfo?.allowed_groups);

  return (
    <PartnerDashboardView
      data={data}
      fehler={fehler}
      headerActions={
        <>
          {!partner && (
            <Link component={RouterLink} to="/" sx={{ fontSize: 13, color: C.brand }}>
              ← Internes Dashboard
            </Link>
          )}
          <Button size="small" variant="outlined" onClick={abmelden} sx={{ textTransform: 'none', borderColor: C.line, color: C.ink2 }}>
            Abmelden
          </Button>
        </>
      }
    />
  );
};

export default MsmPartnerPage;
